import React from 'react';
import SlotManagement from './SlotManagement';

const WorkingHours = () => {
  return <SlotManagement filter="hours" />;
};

export default WorkingHours;
